<template lang='pug'>
    v-row( ).justify-center.align-center.my-4
      v-list(style="max-height: 315px; overflow-y: auto;" two-line="")
        v-list-item-group(v-model="selected" active-class="pink--text")
          template(v-for="(item, index) in videos")
            v-list-item(:key="item.title")
              template(v-slot:default="{ active, toggle }")
                v-list-item-content
                  v-list-item-title()
                    .display-1 {{item.title}}
                  v-list-item-subtitle.text--primary(v-text="item.duration")
                v-list-item-action
                  v-list-item-action
                    v-btn(depressed="" color='secondary' small="")
                      | Ver
                      v-icon(color="primary " right="")
                        | mdi-open-in-new
            v-divider(v-if="index + 1 < videos.length" :key="index")
      v-col(:cols="isMobile ? 12 : 'auto'").justify-center.align-center
        iframe#FrameID( :key='selected' :src="getUrl(selected)" :width="isMobile ? '100%' : 560" height="315" frameborder="0" allowfullscreen="").ma-auto
</template>

<script>

  export default {
    name: 'VideosHowToUse',
    data () {
      return {
        selected: 0,
        videos: [
          {
            color: '#000',
            duration: '1m 41s',
            title: 'Presentation English',
            src: 'https://www.youtube.com/embed/E7km_J1aEKg',
          }, {
            color: '#000',
            duration: '1m 41s',
            title: 'Presentación Español',
            src: 'https://www.youtube.com/embed/elNsCVJ3p_k',
          },
          {
            color: '#000',
            duration: '1m 12s',
            title: '¿Como crear una tienda con TENDER?',
            src: 'https://www.youtube.com/embed/G6McegTj7sY',
          },
          {
            color: '#000',
            duration: '1m 13s',
            title: '¿Como subir mi inventario a TENDER?',
            src: 'https://www.youtube.com/embed/pBvTsLYsiHY',
          },
          {
            color: '#000',
            duration: '1m 33s',
            title: '¿Como generar una factura de venta?',
            src: 'https://www.youtube.com/embed/bEl-cRU5eS0',
          },
        // {
        //   color: '#000',
        //   duration: 120,
        //   title: 'Crear mi primera factura',
        //   src: 'https://www.youtube.com/embed/G6McegTj7sY',
        // },
        // {
        //   color: '#000',
        //   duration: 120,
        //   title: 'Generar una devolucion',
        //   src: 'https://www.youtube.com/embed/G6McegTj7sY',
        // },
        ],
      }
    },
    computed: {
      isMobile () {
        return window.innerWidth < 1024
      },
    },
    methods: {
      getUrl (val) {
        if (this.videos[val]) { return this.videos[val].src || '' } else return ''
      },
    },
  }
</script>
